var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 d-flex align-items-center justify-content-center"},[_c('b-spinner',{style:(("width: " + _vm.size + "rem; height: " + _vm.size + "rem; display: block;")),attrs:{"label":"Spinning","variant":"secondary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }